<template>
  <div>
    <div class="dn db-m db-l relative w-100 ml0 mb0 container-fluid z-content bg-navy">
      <div class="pv2" v-if="$route.path === '/info/'">
        <a class="f4 mh3 mv2 is-tablet-cond-bold lh-copy is-beige pointer link" v-for="(item, index) in info_page.header.sub_nav" v-if="item.is_published" :href="'/info/' + item.link" :title="item.title" :key="'page-nav-items-' + index">{{ item.title }}</a>
      </div>
      <div class="flex flex-row items-center" v-if="$route.path === '/tickets/'">
        <div class="f4 mh3 mv2 is-tablet-cond-bold lh-copy is-beige pointer" v-for="(item, index) in tickets_page.header.mobile_nav"  v-if="item.is_published">
          <a v-if="item.link.includes('#')" class="is-beige pointer link" :href="'/tickets/' + item.link" :title="item.title" :key="'page-nav-items-' + index">{{ item.title }}</a>   
          <router-link v-else class="is-beige pointer link" :to="item.link" :title="item.title" :key="'page-nav-items-' + index">{{ item.title }}</router-link>  
        </div>   
      </div>
    </div>
    <div class="dn dn-ns absolute is-black bg-navy mobile-menu-lineup">
      <div class="relative flex flex-row items-center w-100 h3 bb-grey container-fluid">
        <div class="flex w-100 flex-row justify-between">
          <a class="f3 mt2 ttu is-tablet-bold is-beige pointer" :href="tickets_page.header.mobile_nav[activeItemIndex].link" :title="tickets_page.header.mobile_nav[activeItemIndex].title">{{ tickets_page.header.mobile_nav[activeItemIndex].title }}</a>
          <a class="w2 mt2 inline-flex pointer arrow-down-icon" :class="{ 'is-clicked': mobileMenuIconIsClicked }" @click="mobileMenuIconIsClicked = !mobileMenuIconIsClicked">
            <simple-svg class="green-arrow"
              :filepath="'/uploads/plus.svg'"
              :id="'arrow-down-icon-id'">
            </simple-svg>
          </a>
        </div>
      </div>
      <transition name="slide-fade-rev">
        <div class="absolute bg-navy w-100 z-4000" v-show="mobileMenuIconIsClicked">
          <div class="relative flex flex-row items-center w-100 h3 container-fluid" v-for="(item, index) in tickets_page.header.mobile_nav" v-if="index != activeItemIndex" :key="item.title">
            <a class="f3 ttu mt2  is-tablet-bold is-beige pointer" @click="activeItemIndex = index, mobileMenuIconIsClicked = !mobileMenuIconIsClicked" :href="item.link" :title="item.title">{{ item.title }}</a>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      mobileMenuIconIsClicked: false,
      activeItemIndex: 0
    }
  },
  computed: {
    info_page: function () {
      var pageData = this.$store.getters.filterPagesByName('info.markdown');
      return pageData[0];
    },
    tickets_page: function () {
      var pageData = this.$store.getters.filterPagesByName('tickets.markdown');
      return pageData[0];
    }
  }
}
</script>